import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=4b1c35dc&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=4b1c35dc&prod&lang=less&scoped=true&"
import style1 from "./Modal.vue?vue&type=style&index=1&id=4b1c35dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c35dc",
  null
  
)

export default component.exports